module.exports = "/build/web/svg/sold_out--dark-blue.108b94e1dda2cb0f2b37d60ed6f04a4c.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sold_out--dark-blue.svg
// module id = 204
// module chunks = 24